import React, { useEffect, useState } from "react";
import HeaderRoutes from "../../components/HeaderRoutes/HeaderRoutes";
import { Grid , Box , Paper, Typography , Autocomplete , TextField} from "@mui/material";
import axios from 'axios';
import config from '../../config/config';
import Toast from '../../config/Toast';
import CircularProgress from '@mui/material/CircularProgress';
import PaginationComponent from "../../components/Pagination/Pagination";
import moment from "moment";

const NotificationError = () => {
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [loading , setLoading] = useState(false);
    const [page, setPage] = useState(1); 
    const [totalPages, setTotalPages] = useState(0);
    const [message, setMessage] = useState('');
    const [type, setType] = useState('');
    const [rowList , setRowList] = useState([]);
    const maxLength = 60;
    const [expandedErrors, setExpandedErrors] = useState({});
    const [databaseList , setDatabaseList] = useState([]);
    const [selectedDept , setSelectedDept] = useState('');

    const handleData = async (pageNumber) => {
        setLoading(true)

        const filterData = {
            "department_id" : selectedDept,
        };

        const path = `${config.authServiceUrl}logs/notificationerrors?page=${pageNumber}`;
        const token = localStorage.getItem("tokenId");

        try {
            const response = await axios.post(path , filterData , {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            setLoading(false)
            const { data, last_page } = response.data;
            setRowList(data);         
            setTotalPages(last_page); 

        } catch (error) {
            setLoading(false)
            const apiError = error.response?.data?.message || "An error occurred.";
            setSnackbarOpen(true);
            setMessage(apiError);
            setType("error");
        }
    };

    useEffect(() => {
        handleData(page)
    }, [page , selectedDept]);

    const handleCloseSnackbar = () => {
      setSnackbarOpen(false);
    };

    const toggleExpand = (index) => {
        setExpandedErrors((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    const fetchDatabaseList = () => {
        let path = config.authServiceUrl;
        path = path + 'logs/notificationerrors-deptlist';
      
        const token = localStorage.getItem("tokenId");
        axios.get(path, {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            }
          })
          .then((response) => {
            setDatabaseList(response?.data?.data)
          })
          .catch((error) => {
            console.log('logout failed', error.response?.data?.message || error.message);
          });
    };
    
    useEffect(()=>{
        fetchDatabaseList()
    } , [])

     
  return (
    <>
      <HeaderRoutes />
        <div>
            <Paper sx={{ margin: '16px', padding: '20px'}}>
                <Grid container sx={{ flex: 1 }}>
                    <Grid md={8} sm={12}>
                        <Typography
                            style={{
                                fontFamily: 'Karla',
                                fontStyle: 'normal',
                                fontSize: '20px',
                                color: '#000000',
                                fontWeight: 500,
                                paddingTop:'10px'
                            }}
                        >
                            Notification Errors
                        </Typography>
                    </Grid>
                    <Grid md={4} sm={12}>
                        <Autocomplete
                            className="mt-0 w-100"
                            options={databaseList|| []}
                            getOptionLabel={(option) => option?.department_id + ' , ' + option?.department_name}
                            onChange={(event, value) => {
                                setSelectedDept(value?.department_id);
                                setPage(1);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Database List"
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                    ...params.InputProps,
                                        sx: {
                                            height: '48px',
                                            fontSize: '14px',
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: {
                                            marginTop: '3px',
                                            fontSize: '14px',
                                        },
                                    }}
                                />
                            )}
                            isOptionEqualToValue={(option, value) => option?.department_name === value}
                        />
                    </Grid>
                </Grid>

                {loading && (
                    <Box sx={{display:'flex', justifyContent:'center' , margin:'50px 0px'}}>
                        <CircularProgress />
                    </Box>
                )}

                {!loading && (
                    <div>
                        <Box sx={{ mt: 2}}>
                            {rowList.length === 0 && (
                                <Typography>No errors found.</Typography>
                            )}

                            {
                            rowList.length > 0 && (
                                <Grid container spacing={1.5}>
                                    {rowList.map((items, index) => {
                                        const isExpanded = expandedErrors[index];
                                        const shouldTruncate = items?.error?.length > maxLength;
                                        const displayMessage =
                                            isExpanded || !shouldTruncate
                                            ? items?.error
                                            : `${items?.error.slice(0, maxLength)}...`;

                                        return (
                                            <Grid item md={6} sm={12} key={index}>
                                                <div
                                                    style={{
                                                        border: "1px solid #e0e0e0",
                                                        padding: "20px",
                                                        borderRadius: "16px",
                                                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.05)",
                                                        backgroundColor: "#fff",
                                                        fontFamily: "Open Sans, sans-serif",
                                                    }}
                                                >
                                                    {items?.error && (
                                                    <p
                                                        style={{
                                                            fontSize: "14px",
                                                            color: "#ff0000",
                                                            fontWeight: 600,
                                                            marginBottom: "10px",
                                                        }}
                                                    >
                                                        {displayMessage}{" "}
                                                        {shouldTruncate && (
                                                        <span
                                                            style={{
                                                                color: "#555555",
                                                                cursor: "pointer",
                                                                fontSize:'12px',
                                                                textDecoration: "underline",
                                                            }}
                                                            onClick={() => toggleExpand(index)}
                                                        >
                                                            {isExpanded ? "See less" : "See more"}
                                                        </span>
                                                        )}
                                                    </p>
                                                    )}
                                                    <p style={{ margin: "0", fontSize: "14px" }}>
                                                        <strong>Department ID :</strong> {items?.department_id} , 
                                                    </p>
                                                    <p style={{ margin: "0", fontSize: "14px" }}>
                                                        <strong>Employee ID :</strong> {items?.emp_id}
                                                    </p>
                                                    <p style={{ margin: "0", fontSize: "14px" }}>
                                                        <strong>Title:</strong> {items?.notification_title}
                                                    </p>
                                                    <p style={{ margin: "0", fontSize: "14px" }}>
                                                        <strong>Type:</strong> {items?.type}
                                                    </p>
                                                    <p style={{ margin: "0", fontSize: "14px" }}>
                                                        <strong>Notification Content:</strong>{" "}
                                                        {items?.notification_content}
                                                    </p>
                                                    <p style={{ margin: "0", fontSize: "14px" }}>
                                                        <strong>Created at:</strong>{" "}
                                                        {moment(items?.created_at).format("MM/DD/YYYY , hh:mm:ss")}
                                                    </p>
                                                </div>
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            )}

                            {rowList.length > 0 &&
                                <div style={{ display: "flex", justifyContent: "end", marginTop: 20 }}>
                                    <PaginationComponent
                                        count={totalPages}
                                        page={page}
                                        onChange={(e, value) => setPage(value)}
                                    />
                                </div>
                            }
                        </Box>
                    </div>
                )}
            </Paper>
        </div>

        <Toast
            snackbarOpen={snackbarOpen}
            handleCloseSnackbar={handleCloseSnackbar}
            message={message}
            type={type}
        />
    </>
  );
};

export default NotificationError;



